import { AG_GRID_LOCALE_VN } from "@ag-grid-community/locale";
import {
  Badge,
  Button,
  Flex,
  Grid,
  Select,
  Text,
  TextInput,
} from "@mantine/core";
import { randomId, useDebouncedState, useDisclosure } from "@mantine/hooks";
import {
  IconBuildingSkyscraper,
  IconFileTypeCsv,
  IconSearch,
  IconTicket,
} from "@tabler/icons-react";
import {
  ColDef,
  ColGroupDef,
  DefaultMenuItem,
  GetContextMenuItemsParams,
  GridReadyEvent,
  MenuItemDef,
} from "ag-grid-community";
import {
  GetRowIdParams,
  IServerSideDatasource,
  IServerSideGetRowsRequest,
} from "ag-grid-enterprise";
import { AgGridReact, CustomCellRendererProps } from "ag-grid-react";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useLocation } from "react-router-dom";
import {
  paginationPageSize,
  paginationPageSizeSelector,
  repositoryPos,
} from "../../../../_base/_const/_constVar";
import _breadcrumb from "../../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import LoadingOverlayCustom from "../../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { BASE_API_POS } from "../../../../config";
import { MessageResponse } from "../../../../model/MessageResponse";
import { getMasterOrgSelect } from "../../../../service/getSelectApi";
import { changeSearchValue } from "../../../../_base/helper/FunctionHelper";

const ReportUseVoucher = () => {
  const [loading, setLoading] = useState(true);
  const gridRef = useRef<AgGridReact<any>>(null);
  const [height, setHeight] = useState(825);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [visible, { toggle, open, close }] = useDisclosure(false);
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const containerStyle = useMemo(() => ({ width: "100%", height: height }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

  const [search, setSearch] = useState<any>({
    Branch: _searchJson && checkedPinSearch ? _searchJson?.Branch : "",
  });

  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300,
  );
  const [voucherCode, setVoucherCode] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.voucherCode : "",
    300,
  );
  const [voucherName, setVoucherName] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.voucherName : "",
    300,
  );

  const [dataBranch, setDataBranch] = useState<any[]>([]);

  const fetchData = async (request: IServerSideGetRowsRequest) => {
    open();
    try {
      let url = `/api/v1/VVoucherUsageByBranch/get-list?Skip=${
        request.startRow
      }&Take=${Number(request.endRow) - Number(request.startRow)}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch?.trim()}`;
      }

      if (voucherCode.length > 0) {
        url += `&VoucherCode=${voucherCode}`;
      }

      if (voucherName.length > 0) {
        url += `&VoucherName=${voucherName}`;
      }

      url += `&${params.toString()}`;

      return await repositoryPos.get<MessageResponse<any[]>>(url);
    } catch (error) {
      console.error(error);
    } finally {
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...search,
          keySearch: keySearch,
          voucherCode: voucherCode,
          voucherName: voucherName,
        }),
      );
      close();
    }
  };

  const exportDataExcel = async () => {
    open();
    try {
      let url = "";

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch?.trim()}`;
      }

      if (voucherCode.length > 0) {
        url += `&VoucherCode=${voucherCode}`;
      }

      if (voucherName.length > 0) {
        url += `&VoucherName=${voucherName}`;
      }

      url += `&${params.toString()}`;

      const baseUrl = `/api/v1/VVoucherUsageByBranch/export-excel${url.replace(/^&/, "?")}`;

      const _url = BASE_API_POS + baseUrl;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename = "bao_cao_voucher_su_dung_theo_chi_nhanh.xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        NotificationExtension.Success("Export Excel thành công !");
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const fetchDataBranch = async () => {
    const res = await getMasterOrgSelect();

    if (res) {
      const data = res
        .filter((i) => i.text && i.att1)
        .map((i) => ({
          label: `${i.att1} - ${i.text}`,
          value: String(i.text),
        }));

      setDataBranch(data);
    }
  };

  const getServerSideDataSource: () => IServerSideDatasource = () => {
    return {
      getRows: async (params) => {
        var response = await fetchData(params.request);
        // adding delay to simulate real server call

        if (response && response.success) {
          params.success({
            rowData: response.data.map((i, index) => ({
              ...i,
              id: Number(params.request.startRow) + index + 1,
            })),
            rowCount: response.totalCount,
          });
          setLoading(false);
        } else {
          // inform the grid request failed
          params.fail();
          setLoading(false);
        }
      },
    };
  };

  const getRowId = useCallback((params: GetRowIdParams) => {
    if (params.data.id != null) {
      return "leaf-" + randomId();
    }
    const rowGroupCols = params.api.getRowGroupColumns();
    const rowGroupColIds = rowGroupCols.map((col) => col.getId()).join("-");
    const thisGroupCol = rowGroupCols[params.level];
    return (
      "group-" +
      rowGroupColIds +
      "-" +
      (params.parentKeys || []).join("-") +
      params.data[thisGroupCol.getColDef().field!]
    );
  }, []);

  const getRowStyle = useCallback((params: any) => {
    if (params.node.rowPinned) {
      return {
        backgroundColor: "#e7f5ff",
        fontWeight: 700,
        fontSize: "14px",
        borderTop: "3px solid #15aabf",
      };
    }
    return undefined;
  }, []);

  const filterParamsDefault = {
    buttons: ["clear", "reset", "apply"],
    debounceMs: 1000,
    maxNumConditions: 5,
  };

  const columnDefs = useMemo<(ColDef | ColGroupDef)[]>(
    () => [
      {
        field: "voucherCode",
        headerName: "Mã voucher",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Badge color="green" variant="dot">
              {params.value}
            </Badge>
          );
        },
      },
      {
        field: "voucherName",
        headerName: "Tên voucher",
      },
      {
        field: "voucherValue",
        headerName: "Giá trị voucher",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {String(params.data.voucherType) === "1"
                ? Number(params.value).toLocaleString()
                : params.value}{" "}
              {String(params.data.voucherType) === "1"
                ? "VNĐ"
                : String(params.data.voucherType) === "2"
                  ? "%"
                  : ""}
            </Text>
          );
        },
      },
      {
        field: "maxDiscountAmount",
        headerName: "Tiền giảm tối đa",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value || params.value === 0
                ? `${Number(params.value).toLocaleString()} VNĐ`
                : ""}
            </Text>
          );
        },
      },
      {
        field: "totalAmount",
        headerName: "Số lượng voucher",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {params.value === "n" ? "Không giới hạn" : params.value}
            </Text>
          );
        },
      },
      {
        field: "usedQuantity",
        headerName: "Số lượng voucher đã sử dụng",
      },
      {
        field: "branch",
        headerName: "Chi nhánh",
      },
    ],
    [],
  );

  const defaultColDef = useMemo<ColDef>(() => {
    return {
      flex: 1, // Tự động dàn đều các cột
      autoHeaderHeight: true,
      allowedAggFuncs: ["sum", "min", "max", "avg"],
      filter: false,
      enableRowGroup: true,
      enableValue: true,
      floatingFilter: false,
      floatingFilterComponentParams: {
        showDisabledCheckboxes: true,
      },
      filterParams: filterParamsDefault,
    };
  }, []);

  const defaultColGroupDef = useMemo<Partial<ColGroupDef>>(() => {
    return {
      headerName: "A shared prop for all Groups",
    };
  }, []);

  const onGridReady = useCallback(async (params: GridReadyEvent) => {
    var datasource = getServerSideDataSource();
    // register the datasource with the grid
    params.api!.setGridOption("serverSideDatasource", datasource);
  }, []);

  const handleSearch = useCallback(() => {
    if (gridRef.current && gridRef.current.api) {
      setLoading(true);
      // Lấy datasource mới chứa state search hiện tại
      const datasource = getServerSideDataSource();
      // Set lại datasource để Grid query lại từ đầu (trang 1) với params mới
      gridRef.current.api.setGridOption("serverSideDatasource", datasource);
    }
  }, [search, keySearch, voucherCode, voucherName]); // Dependency quan trọng để lấy state mới

  const statusBar = useMemo(
    () => ({
      statusPanels: [
        { statusPanel: "agTotalAndFilteredRowCountComponent" },
        { statusPanel: "agTotalRowCountComponent" },
        { statusPanel: "agFilteredRowCountComponent" },
        { statusPanel: "agSelectedRowCountComponent" },
        { statusPanel: "agAggregationComponent" },
      ],
    }),
    [],
  );

  const getContextMenuItems = useCallback(
    (params: GetContextMenuItemsParams): (DefaultMenuItem | MenuItemDef)[] => {
      var result: (DefaultMenuItem | MenuItemDef)[] = [
        "cut",
        "copy",
        "copyWithHeaders",
        "copyWithGroupHeaders",
        "paste",
        "separator",
        "chartRange",
        "export",
      ];
      return result;
    },
    [window],
  );

  useEffect(() => {
    fetchDataBranch();
  }, []);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 160 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (245 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  return (
    <div style={containerStyle}>
      <LoadingOverlayCustom visible={visible} />
      <Flex justify={"space-between"} align={"center"} w={"100%"}>
        <_breadcrumb></_breadcrumb>
        <Flex gap={"md"}>
          <Button
            leftSection={<IconFileTypeCsv size={16} />}
            onClick={() => exportDataExcel()}
          >
            Export Excel
          </Button>
        </Flex>
      </Flex>
      <Grid mb={10}>
        <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
          <TextInput
            placeholder="Nhập từ khóa tìm kiếm"
            leftSection={<IconSearch color="#15aabf" />}
            defaultValue={keySearch}
            onChange={(e) => setKeySearch(e.currentTarget.value)}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
          <TextInput
            placeholder="Mã voucher"
            leftSection={<IconTicket color="#15aabf" />}
            defaultValue={voucherCode}
            onChange={(e) => setVoucherCode(e.currentTarget.value)}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
          <TextInput
            placeholder="Tên voucher"
            leftSection={<IconTicket color="#15aabf" />}
            defaultValue={voucherName}
            onChange={(e) => setVoucherName(e.currentTarget.value)}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
          <Select
            placeholder="Chi nhánh"
            leftSection={<IconBuildingSkyscraper color="#15aabf" />}
            data={dataBranch}
            value={search.Branch || null}
            onChange={(e) => {
              changeSearchValue(e ? e : "", "Branch", setSearch);
            }}
            searchable
            clearable
            nothingFoundMessage="Không tìm thấy dữ liệu !"
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
          <Button
            leftSection={<IconSearch size={14} />}
            onClick={() => handleSearch()}
          >
            Tìm kiếm
          </Button>
        </Grid.Col>
      </Grid>
      <div style={gridStyle} className={"ag-theme-quartz"}>
        <AgGridReact<any>
          ref={gridRef}
          loading={loading}
          suppressNoRowsOverlay
          columnDefs={columnDefs}
          defaultColGroupDef={defaultColGroupDef}
          defaultColDef={defaultColDef}
          rowModelType={"serverSide"}
          pagination={true}
          paginationPageSize={paginationPageSize}
          paginationPageSizeSelector={paginationPageSizeSelector}
          cacheBlockSize={paginationPageSize}
          maxBlocksInCache={10}
          onGridReady={onGridReady}
          localeText={AG_GRID_LOCALE_VN}
          sideBar={true}
          enableAdvancedFilter={false}
          masterDetail={true}
          // detailCellRendererParams={detailCellRendererParams}
          rowSelection={"multiple"}
          suppressAggFuncInHeader={true}
          getRowId={getRowId}
          suppressRowClickSelection={true}
          groupSelectsChildren={true}
          blockLoadDebounceMillis={200}
          suppressServerSideFullWidthLoadingRow={false}
          maxConcurrentDatasourceRequests={1}
          animateRows={true}
          rowBuffer={paginationPageSize}
          purgeClosedRowNodes={true}
          pivotPanelShow={"always"}
          rowGroupPanelShow={"always"}
          statusBar={statusBar}
          enableRangeSelection
          enableCharts
          allowContextMenuWithControlKey={true}
          getContextMenuItems={getContextMenuItems}
          suppressColumnVirtualisation
          paginateChildRows={true}
          paginationAutoPageSize={true}
          //   pinnedBottomRowData={totalRow}
          getRowStyle={getRowStyle}
        />
      </div>
    </div>
  );
};

export default ReportUseVoucher;
